/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { mergeListById } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AssignUserModal from "components/Common/Modal/AssignUserModal";
import { assetImages } from "constants";
import MedicalRecordFilter from "./Popup/MedicalRecordFilter";
import SaveMedicalCondtionPopup from "components/Common/Popup/SaveMedicalCondtionPopup";

const MedicalRecordSection = ({ patientObj = null }) => {
  const params = useParams();
  const { t } = useTranslation();
  const token = localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState(false);
  const [conditionList, setConditionList] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedConditionIds, setSelectedConditionIds] = useState([]);
  const [selectedConditionId, setSelectedConditionId] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  //function for get all conditions
  const getAllConditions = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MEDICAL_CONDITION +
        `?token=${token}&members=${params.id}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      console.log("response", response);

      if (response.status) {
        setConditionList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for bulk update condition
  const updateBulkConditionHandler = async () => {
    if (selectedConditionIds.length > 0) {
      try {
        const conditionListToBeUpdate = conditionList
          .filter((item) => selectedConditionIds.includes(item._id))
          .map((item) => {
            return {
              _id: item._id,
              condition: item.condition,
              conditionname: item.conditionname,
              reportedon: item.reportedon,
              resolvedon: item.resolvedon,
              currentstatus: item.currentstatus,
            };
          });

        let conditionData = {
          medicalconditionlist: conditionListToBeUpdate,
        };

        console.log(
          "conditionData in update bulk condition handler",
          conditionData
        );

        let requestURL =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_MEDICAL_CONDITION +
          `?token=${token}`;

        const response = await putData(requestURL, conditionData);

        console.log("response in update bulk condition handler", response);

        if (response.status) {
          setTimeout(() => {
            setSelectedConditionIds([]);
            setRowSelection({});
          }, 1500);
        } else {
        }
      } catch (error) {
        console.log(error.message);
      }
    } else {
    }
  };

  //function for delete condition
  const deleteBulkConditionHandler = async () => {
    if (selectedConditionIds.length > 0) {
      try {
        const conditionListToBeDelete = conditionList.filter((item) =>
          selectedConditionIds.includes(item._id)
        );

        let conditionData = {
          medicalconditionlist: conditionListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_MEDICAL_CONDITION +
          `?token=${token}`;

        const response = await putData(requestURL, conditionData);

        console.log(response);

        if (response.status) {
          setTimeout(() => {
            setConditionList((prevList) =>
              prevList.filter(
                (item) => !selectedConditionIds.includes(item._id)
              )
            );

            setSelectedConditionIds([]);
            setRowSelection({});
          }, 1500);
        } else {
        }
      } catch (error) {
        console.log(error.message);
      }
    } else {
    }
  };

  //function for after any action
  const afterActionClose = (data = []) => {
    setConditionList((prevList) => mergeListById(prevList, data));
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllConditions();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllConditions();
      setReloadData(false);
    }
  }, [reloadData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveMedicalConditionOffCanvas"
            aria-controls="saveMedicalConditionOffCanvas"
            onClick={() => {
              setSelectedConditionId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Name",
        accessorKey: "condition",
        size: 200,
        Cell: ({ row }) => (
          <span>
            {row.original.conditionname && row.original.conditionname !== "" ? (
              row.original.conditionname
            ) : (
              <span style={{ color: "#bbb" }}></span>
            )}
          </span>
        ),
      },
      {
        header: "Reported Date",
        accessorKey: "reportedondate",
        size: 160,
        Cell: ({ row }) => (
          <div className="joined border-bottom-0">
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">{row.original.reportedondate}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Resolved Date",
        accessorKey: "resolvedondate",
        size: 160,
        Cell: ({ row }) => (
          <div
            className={
              row.original.resolvedondate === ""
                ? "d-none"
                : "joined border-bottom-0"
            }
          >
            <p className="d-flex align-items-center gap-2">
              <span className="d-block material-symbols-outlined icon-md">
                calendar_month
              </span>
              <span className="d-block">{row.original.resolvedondate}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Current Status",
        accessorKey: "currentstatus",
        Cell: ({ row }) => (
          <span>
            {typeof row.original.currentstatus === "string" &&
            row.original.currentstatus !== "" ? (
              row.original.currentstatus
            ) : (
              <span style={{ color: "#bbb" }}></span>
            )}
          </span>
        ),
      },
      {
        header: "Assigned To",
        accessorKey: "assignedpersonname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.assignedpersonname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assignedpersonimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assignedpersonimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.assignedpersonname}</span>
            </p>
            {/* <button
                        onClick={() => {
                          createTaskChatHandler(row.original._id);
                        }}
                        className={
                          row.original.moderator.toString() === userInfo._id.toString()
                            ? "d-none"
                            : "d-flex align-items-center ms-auto border-0 bg-light"
                        }
                      >
                        <span className="d-block material-symbols-outlined icon-md text-primary">
                          chat
                        </span>
                      </button> */}
          </div>
        ),
      },
    ],
    []
  );

  //initialize the column order
  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedConditionIds(selectedIdsArray);
  }, [rowSelection]);

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center mb-4">
          <div className="col-lg-4">
            <h3 className="mb-0">Medical Conditions</h3>
          </div>
          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray" onClick={resetFilterData}>
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>
            <Link
              to="#"
              className="btn btn-gray"
              data-bs-toggle="offcanvas"
              data-bs-target="#medicalRecordFilterOffCanvas"
              aria-controls="medicalRecordFilterOffCanvas"
            >
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
            <Link
              to="#saveMedicalConditionOffCanvas"
              className="btn btn-primary"
              data-bs-toggle="offcanvas"
            >
              Add New
            </Link>
          </div>
        </div>
      </div>

      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <div className="table-wrapper">
          <MaterialReactTable
            columns={columns}
            data={conditionList}
            enableGrouping
            enableRowSelection
            getRowId={(row) => row._id}
            onRowSelectionChange={setRowSelection}
            state={{ rowSelection, columnOrder }}
            initialState={{ rowSelection, columnOrder }}
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50,
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      )}

      <SaveMedicalCondtionPopup
        patientObj={patientObj}
        selectedConditionId={selectedConditionId}
        setSelectedConditionId={setSelectedConditionId}
        afterActionClose={afterActionClose}
      />

      <AssignUserModal
        moduleName="condition"
        afterModalClose={afterActionClose}
        selectedIds={selectedConditionIds}
        onModalClose={() => {
          setRowSelection({});
          setSelectedConditionIds([]);
        }}
      />

      <DeleteWarningModal
        onDelete={deleteBulkConditionHandler}
        onCancelDelete={() => {
          setRowSelection({});
          setSelectedConditionIds([]);
        }}
        moduleName={t("Medical Records")}
      />

      <MedicalRecordFilter
        moduleSlug="medicalrecord"
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={resetFilterData}
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
      />
    </div>
  );
};

export default MedicalRecordSection;
